export const SET_AUTH_LOADING = 'SET_AUTH_LOADING'
export const SET_AUTH_DATA = 'SET_AUTH_DATA'
export const SET_AUTH_ERROR = 'SET_AUTH_ERROR'
export const SIGNED_OUT = 'SIGNED_OUT'

export const SET_DASHBOARD_LOADING = 'SET_DASHBOARD_LOADING'
export const SET_DASHBOARD_LOGS = 'SET_DASHBOARD_LOGS'
export const SET_DASHBOARD_SERVERS = 'SET_DASHBOARD_SERVERS'
export const SET_CONS_FILE = 'SET_CONS_FILE'
export const SET_EXCHANGE_CONS = 'SET_EXCHANGE_CONS'

export const SET_SERVERS_LOADING = 'SET_SERVERS_LOADING'
export const SET_SERVERS_DATA = 'SET_SERVERS_DATA'
export const ADD_SERVER = 'ADD_SERVER'
export const UPDATE_SERVER = 'UPDATE_SERVER'
export const DELETE_SERVER = 'DELETE_SERVER'

export const SET_GUK_SERVERS_DATA = 'SET_GUK_SERVERS_DATA'
export const SET_GUK_SERVERS_LOADING = 'SET_GUK_SERVERS_LOADING'

export const SET_AREAS_LOADING = 'SET_AREAS_LOADING'
export const SET_AREAS_DATA = 'SET_AREAS_DATA'

export const SET_REGIONS_LOADING = 'SET_REGIONS_LOADING'
export const SET_REGIONS_DATA = 'SET_REGIONS_DATA'